<!-- src/routes/terms.svelte -->
<script>
  const last_updated = "March 28, 2024";
  import { onMount } from 'svelte';
  
  onMount(() => {
    // Add meta robots tag to prevent indexing
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex';
    document.head.appendChild(metaRobots);
  });
</script>

<section class="terms_page">
  <div class="content_wrapper">
    <h1>Terms of Service</h1>
    <p class="last_updated">Last updated: {last_updated}</p>

    <div class="terms_content">
      <p>Please read these Terms of Service carefully before using our Service.</p>

      <h2>Interpretation and Definitions</h2>

      <h3>Interpretation</h3>
      <p>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>

      <h3>Definitions</h3>
      <ul>
        <li><strong>"Account"</strong> means a unique account created for You to access our Service or parts of our Service.</li>
        <li><strong>"Company"</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Down to Earth Guides.</li>
        <li><strong>"Content"</strong> refers to content such as text, images, or other information that can be posted, uploaded, linked to or otherwise made available by You, regardless of the form of that content.</li>
        <li><strong>"Service"</strong> refers to the Website.</li>
        <li><strong>"Website"</strong> refers to Down to Earth Guides, accessible from https://downtoearthguides.com</li>
        <li><strong>"You"</strong> means the individual accessing or using the Service.</li>
      </ul>

      <h2>Content</h2>
      <p>Our Service allows You to post Content. You are responsible for the Content that You post to the Service, including its legality, reliability, and appropriateness.</p>

      <p>By posting Content to the Service, You grant Us the right and license to use, modify, publicly perform, publicly display, reproduce, and distribute such Content on and through the Service.</p>

      <h2>Your Account</h2>
      <p>When You create an account with Us, You must provide information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of Your account.</p>

      <h2>Intellectual Property</h2>
      <p>The Service and its original content (excluding Content provided by You or other users), features and functionality are and will remain the exclusive property of the Company and its licensors.</p>

      <h2>User Conduct</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the Service for any illegal purpose</li>
        <li>Violate any intellectual property rights</li>
        <li>Harass, abuse, or harm others</li>
        <li>Interfere with or disrupt the Service</li>
        <li>Use the Service to distribute malware or malicious code</li>
      </ul>

      <h2>Termination</h2>
      <p>We may terminate or suspend Your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if You breach the Terms.</p>

      <h2>Contact Us</h2>
      <p>If you have any questions about these Terms of Service, please contact us at:</p>
      <p>Email: team@downtoearthguides.com</p>
    </div>
  </div>
</section>

<style>
  .terms_page {
    padding: 6rem 2rem;
    background: var(--color-background);
    color: var(--color-text);
  }

  .content_wrapper {
    max-width: 800px;
    margin: 0 auto;
  }

  h1 {
    font-size: 2.5rem;
    margin-bottom: 1rem;
    color: var(--color-primary);
  }

  .last_updated {
    color: var(--color-text-muted);
    margin-bottom: 2rem;
  }

  .terms_content {
    font-size: 1.1rem;
    line-height: 1.6;
  }

  h2 {
    font-size: 1.8rem;
    margin: 2rem 0 1rem;
    color: var(--color-primary);
  }

  h3 {
    font-size: 1.4rem;
    margin: 1.5rem 0 1rem;
  }

  p {
    margin-bottom: 1rem;
  }

  ul {
    margin-bottom: 1rem;
    padding-left: 2rem;
  }

  li {
    margin-bottom: 0.5rem;
  }

  strong {
    color: var(--color-primary);
  }

  @media (max-width: 768px) {
    .terms_page {
      padding: 4rem 1rem;
    }

    h1 {
      font-size: 2rem;
    }

    h2 {
      font-size: 1.6rem;
    }

    h3 {
      font-size: 1.3rem;
    }

    .terms_content {
      font-size: 1rem;
    }
  }
</style> 